import React from 'react';
import styled from '@emotion/styled';
import { darken } from 'color2k';
import { Flex } from '$components/layouts';
import { Link } from '$components/elements/link';

type Props = {
    withBackground?: boolean;
    onClick?: () => void;
    href?: string;
    children?: React.ReactNode;
    hideButtonBorder?: boolean;
};

export const UspItem = ({ withBackground, children, href, hideButtonBorder, onClick }: Props) => {
    if (onClick) {
        return (
            <UspButton onClick={onClick} hideButtonBorder={hideButtonBorder}>
                <Usp gap="extrasmall" withBackground={withBackground} noBorder>
                    {children}
                </Usp>
            </UspButton>
        );
    }

    if (href) {
        return (
            <LinkButton href={href} target="_blank">
                <Usp gap="extrasmall" withBackground={withBackground} noBorder>
                    {children}
                </Usp>
            </LinkButton>
        );
    }

    return (
        <Usp gap="extrasmall" withBackground={withBackground}>
            {children}
        </Usp>
    );
};

const Usp = styled(Flex)<{ withBackground?: boolean; noBorder?: boolean }>(
    ({ withBackground, noBorder = false, theme }) => ({
        minHeight: '63px',
        width: '100%',
        padding: `${theme.space[5]} ${theme.space[5]} ${theme.space[5]} ${theme.space[4]}`,
        ...(!noBorder && {
            borderBottom: theme.general.border,
        }),
        alignItems: 'center',
        ...(withBackground && {
            backgroundColor: theme.colors.pickup,
        }),
    })
);
const UspButton = styled.button<{ hideButtonBorder?: boolean }>(({ hideButtonBorder, theme }) => ({
    all: 'unset',
    boxSizing: 'border-box',
    cursor: 'pointer',
    display: 'flex',
    width: '100%',
    borderBottom: hideButtonBorder ? 0 : theme.general.border,
    borderRadius: 0,
    ':hover': {
        borderRadius: theme.general.borderRadius,
        backgroundColor: darken(theme.colors.white, 0.05),
    },
}));

const LinkButton = styled(Link)(({ theme }) => ({
    [`:hover ${Usp}`]: {
        backgroundColor: darken(theme.colors.white, 0.05),
    },
}));
